// extracted by mini-css-extract-plugin
module.exports = {"comp":"h5_comp__SZefc"};